import React, { useEffect, useRef, useState } from "react";
import "../../../assets/scss/base/pages/account/AddressBook/showMoreLess.scss";

const ShowMoreLessText = ({ text, lines = 2 }) => {
  const textRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const el = textRef.current;
      setShowButton(el.scrollHeight > el.clientHeight);
    }
  }, [text]);

  return (
    <div className="show-more">
      <p
        ref={textRef}
        className={`show-more__text ${expanded ? "is-expanded" : ""}`}
        style={{ WebkitLineClamp: expanded ? "unset" : lines }}
      >
        {text}
      </p>

      {showButton && (
        <button
          className="show-more__btn"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Less" : "+ More"}
        </button>
      )}
    </div>
  );
};

export default ShowMoreLessText;
